import { PATHS } from '@/constants';
import { readListingNavState } from '@/hooks';
import type { ObjectViewSource } from '@/lib/analytics';
import { SearchTabs } from '@/types';

const SEARCH_PAGES: string[] = [PATHS.HOUSING, PATHS.PROJECTS];

export const getObjectViewSource = (objectId: string): ObjectViewSource => {
  const navState = readListingNavState();
  if (!navState || String(navState.objectId) !== objectId) return 'direct';

  const listUrl = new URL(navState.listUrl, window.location.origin);
  const page = listUrl.pathname.split('/').pop() ?? '';
  if (!SEARCH_PAGES.includes(page)) return 'direct';

  return listUrl.searchParams.get('tabs') === SearchTabs.MAP ? 'map' : 'list';
};
